import { useEffect } from "react";

import { createFormHelper } from "lib/Form";
import { useOneIPlanningMechanicsQuery, usePlanItMechanicsQuery } from "modules/UsersDashboard/components/PairUsers/hooks";

import type { CreateEditUserForm } from "modules/UsersDashboard/components";

const FormHelper = createFormHelper<CreateEditUserForm>();

export const useMechanicsOptions = () => {
  const { watch } = FormHelper.useFormContext();
  const [dealerLocationId] = watch(["dealer_location_id"]);

  const { data: planItMechanics, refetch: refetchPlanItMechanics } = usePlanItMechanicsQuery(dealerLocationId ? [dealerLocationId] : [0]);
  const { data: oneIPlanningMechanics, refetch: refetchOneIPlanningMechanics } = useOneIPlanningMechanicsQuery(dealerLocationId ? [dealerLocationId] : [0]);

  useEffect(() => {
    if (!dealerLocationId) return;
    refetchPlanItMechanics();
    refetchOneIPlanningMechanics();
  }, [dealerLocationId]);

  const plainItMechanicsOptions =
    planItMechanics?.map(({ planit_planning_mechanic_id, planit_mechanic_name, planit_user_id }) => ({
      key: planit_planning_mechanic_id,
      value: planit_planning_mechanic_id,
      text: planit_mechanic_name,
      disabled: Boolean(planit_user_id)
    })) || [];

  const oneIPlanningMechanicsOptions =
    oneIPlanningMechanics?.map(({ onei_planning_monteur_id, onei_monteur_name, onei_user_id }) => ({
      key: onei_planning_monteur_id,
      value: onei_planning_monteur_id,
      text: onei_monteur_name,
      disabled: Boolean(onei_user_id)
    })) || [];

  return { plainItMechanicsOptions, oneIPlanningMechanicsOptions };
};
